import { render, staticRenderFns } from "./YardAddressForm.vue?vue&type=template&id=80ec52fa&"
import script from "./YardAddressForm.vue?vue&type=script&lang=js&"
export * from "./YardAddressForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports